module.exports = __webpack_public_path__ + "img/logo2.bd2edc22.png";